import { useEffect, useState } from "react";
import NeqatyNavbar from "../components/NeqatyNavbar";
import { useAdminAuth } from "../context/AdminAuthContext";
import { fetchPointsRequests, grantUserPoints } from "../services/neqaty";
import LoadingScreen from "../components/LoadingScreen";
import { Navigate, useLocation } from "react-router-dom";
import { NEQATY_PERMISSION_STATUS } from "../constants/constants";
import DenyAccessPage from "../components/DenyAccessPage";
// images
import background from '../assets/neqatyBackground.jpg';

const NeqatySchoolPermissions = () => {
    const { adminInfo } = useAdminAuth();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [pointsRequests, setPointsRequests] = useState([]);
    const [updateStatus, setUpdateStatus] = useState({});
    const [selectedStatus, setSelectedStatus] = useState({
        id: "",
        status: ""
    });

    const handleSelectChange = (event, id) => {
        setSelectedStatus({ id, status: event.target.value });
    };

    const handleCheck = (id) => {
        setUpdateStatus((prev) => ({ ...prev, [id]: true }));
    };

    const handleConfirm = async (id) => {
        try {
            const request = {
                id: selectedStatus?.id,
                status: selectedStatus?.status,
                adminId: adminInfo.id
            }
            const response = await grantUserPoints(request)
            setUpdateStatus((prev) => ({ ...prev, [id]: false }));
        } catch (err) {

        }
    };

    useEffect(() => {
        const fetchVtcPermissions = async () => {
            try {
                const requests = await fetchPointsRequests();
                const filteredRequest = requests.filter(request => request.point.type === "vtc_reward" || request.point.type === "vtc_punishment");
                setPointsRequests(filteredRequest)
            } catch (err) {
                console.error("API Error:", err);
                setError(err);
            } finally {
                setLoading(false);
            }
        }

        fetchVtcPermissions();
    }, [adminInfo]);

    if (loading) return <LoadingScreen />;
    if (error?.status === 403) return <Navigate to="/login" state={{ from: location }} replace />;
    if (error) return <p>Error: {error.message}</p>;
    if (adminInfo?.user_role !== "ceo" && adminInfo?.user_role !== "super_admin") return <DenyAccessPage homePage='/neqaty' />;

    return (
        <>
            <NeqatyNavbar />
            <div className="w-full h-[89vh] flex flex-col items-center" style={{ backgroundImage: `url(${background})` }}>
                <div className="w-[90%] bg-slate-100 rounded shadow-md shadow-black mt-5">
                    {pointsRequests.length > 0 ? pointsRequests.map((request) => {
                        const id = request.id;
                        const isChecked = updateStatus[id];

                        return (
                            <div key={id} className="py-2 m-2 bg-slate-300 flex justify-between items-center px-4">
                                <div className="w-[11%]">{`${request.admin.userPoints.employee?.first_name} ${request.admin.userPoints.employee?.middle_name} ${request.admin.userPoints.employee?.last_name}`}</div>
                                <div className="w-[11%]">{`${request.userPoints.user.employee?.first_name} ${request.userPoints.user.employee?.middle_name} ${request.userPoints.user.employee?.last_name}`}</div>
                                <div className="w-[3%]">{request.userPoints.points}</div>
                                <div className="w-[25%]">{request.point.name}</div>
                                <div className="w-[4%]">{request.point.points}</div>
                                <div className="w-[7%]">{request.point.type}</div>
                                {isChecked ? <select className="w-[7%]" value={selectedStatus.status}
                                    onChange={(e) => handleSelectChange(e, id)}>
                                    <option key="option" value="" disabled>
                                        please select a status
                                    </option>
                                    {NEQATY_PERMISSION_STATUS.map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select> : <div className="w-[7%]">{request.status}</div>}

                                {isChecked ? (
                                    <button
                                        className="w-[7%] p-2 bg-wisdomOrange text-white rounded"
                                        onClick={() => handleConfirm(id)}
                                    >
                                        confirm
                                    </button>
                                ) : (
                                    <button
                                        className="w-[7%] p-2 bg-wisdomOrange text-white rounded"
                                        onClick={() => handleCheck(id)}
                                    >
                                        check
                                    </button>
                                )}
                            </div>
                        );
                    }) : <div className="text-center p-2 font-bold">there is no requests available</div>}
                </div>
            </div>
        </>
    )
}

export default NeqatySchoolPermissions;